
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MsrInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"msrs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"msr"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"msrs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"msr"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"msrs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"msr"},"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ob"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"worst_score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"best_score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_messages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_assessment_types"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workout"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"start_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"workoutId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_message"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailed_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score_emailed_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workout_emailed_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assessment_type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessType"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Assessment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessInfo"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client"},"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MsrInfo"},"directives":[]}]}}],"loc":{"start":0,"end":784}};
    doc.loc.source = {"body":"#import './client'\n#import './measure'\n#import './ob'\n\nfragment MsrInfo on Assessment {\n  msrs {\n    ...msr\n    msrs {\n      ...msr\n      msrs {\n        ...msr\n      }\n    }\n  }\n  obs {\n    ...ob\n  }\n}\n\nfragment AssessType on AssessmentType{\n  id\n  name\n  description\n  risk\n  worst_score\n  best_score\n  score_messages\n  _assessment_types {\n    id\n    name\n    description\n  }\n}\n\nfragment AssessInfo on Assessment {\n  id\n  name\n  workout {\n    id\n    state\n    start_date\n    compliance\n  }\n  workoutId\n  created_at\n  result {\n    result_text\n    score\n    score_message\n  }\n  completed_at\n  emailed_at\n  score_emailed_at\n  workout_emailed_at\n  assessment_type {\n    ...AssessType\n  }\n}\n\nfragment Assessment on Assessment {\n  ...AssessInfo\n  client {\n    ...Client\n  }\n  ...MsrInfo\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./client').definitions));
doc.definitions = doc.definitions.concat(unique(require('./measure').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ob').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["MsrInfo"] = oneQuery(doc, "MsrInfo");
        
        module.exports["AssessType"] = oneQuery(doc, "AssessType");
        
        module.exports["AssessInfo"] = oneQuery(doc, "AssessInfo");
        
        module.exports["Assessment"] = oneQuery(doc, "Assessment");
        
